import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { DepositPageVarsBanner } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { IconSize } from '@freelancer/ui/icon';
import * as Rx from 'rxjs';
import {
  FinopsResult,
  FinopsResultStatus,
} from '../../common/finops-messaging/finops-messaging.types';
import { FinopsTrackingService } from '../../common/finops-tracking/finops-tracking.service';
import {
  ApplicationType,
  DepositContext,
  DepositModalItem,
} from '../../common/types';

@Component({
  template: `
    <app-payments class="PaymentsModalContainer"
      flTrackingSection="section"
      [depositContext$]="depositContext$"
      (depositResult)="handleDepositResult($event)"
    ></app-payments>
  `,
  styleUrls: ['./payments-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentsModalComponent implements OnInit {
  IconSize = IconSize;
  section = ApplicationType.DEPOSIT_MODAL;

  depositContext$: Rx.Observable<DepositContext>;

  @Input() banner?: DepositPageVarsBanner;
  @Input() chargeAmount: number;
  @Input() chargeCurrencyId: number;
  @Input() items?: ReadonlyArray<DepositModalItem>;
  @Input() trackingToken?: string;
  @Input() checkBalance = true;

  constructor(
    private modalRef: ModalRef<PaymentsModalComponent>,
    private finopTracking: FinopsTrackingService,
  ) {}

  ngOnInit() {
    this.finopTracking.initiate(this.section);
    this.depositContext$ = Rx.of({
      chargeAmount: this.chargeAmount,
      chargeCurrencyId: this.chargeCurrencyId,
      trackingToken: this.trackingToken,
      banner: this.banner || {},
      items: this.items || [],
      backUrl: undefined, // we can't really have a back url in modal
      applicationType: this.section,
      checkBalance: this.checkBalance,
      onSuccess: () => this.close({ finopsStatus: FinopsResultStatus.SUCCESS }),
    });
  }

  close(
    depositResult: FinopsResult = {
      finopsStatus: FinopsResultStatus.INTERRUPTED,
    },
  ) {
    // we can pass the whole object if we need to
    this.modalRef.close(depositResult.finopsStatus);
  }

  handleDepositResult(depositResult: FinopsResult) {
    this.close(depositResult);
  }
}
